import { Parhato2ProductSubscription } from "@core/types";
import { productsClient } from "@core/clients";
import { useQuery, UseQueryOptions } from "@tanstack/react-query";
import { PRODUCTS_QUERY_CACHE_EXPIRE_TIME_MS } from "../../config/constansts";

const useGetAllProductsSubscriptionsQuery = (options: UseQueryOptions<Parhato2ProductSubscription[]> = {}) => {
  return useQuery<Parhato2ProductSubscription[], any>(
    ["product-subscriptions"],
    async () => {
      return await productsClient.getAllProductsSubscriptions();
    },
    {
      cacheTime: PRODUCTS_QUERY_CACHE_EXPIRE_TIME_MS,
      staleTime: PRODUCTS_QUERY_CACHE_EXPIRE_TIME_MS,
      ...options,
    }
  );
};

export default useGetAllProductsSubscriptionsQuery;
